import { useContext, useDebugValue } from 'react'
import { AuthContext } from '../context/login/AuthContext';

const useAuth = () => {
  const { currentUser } = useContext(AuthContext)
  useDebugValue(currentUser, (user) => (user ? 'Logged In' : 'Logged Out'))
  return useContext(AuthContext)
}

export default useAuth
